export default __webpack_public_path__ + "locales/lv/PeopleTranslations.json?hash=1966327107d3e986d4b3912079951245";